export default __webpack_public_path__ + "static/media/Gagan.fc6c88a0.jpg";